<script lang="ts">
  import { onMount } from "svelte"
  import { createExpectedOptions } from "./data"
  import { formatDate } from "$app/utils"

  interface Props {
    dates: { quarter: number; year: number }
    expected_at: any
    rangeOptions?: any
    onselected: (det: any) => void
  }

  let {
    dates,
    expected_at = $bindable(),
    rangeOptions = [
      "Current Quarter",
      "Current Year",
      "Next Quarter",
      "Next Year",
      "Previous Quarter",
      "Previous Year"
    ],
    onselected
  }: Props = $props()

  let expected_group: string = $state("")
  let date_start: string = $state("")
  let date_end: string = $state("")

  const expectedOptions = createExpectedOptions(dates, rangeOptions)

  function createDateRangeString({
    date_start,
    date_end
  }: DateRangeType): string {
    if (date_start && date_end) {
      return `${formatDate(date_start)} to ${formatDate(date_end)}`
    } else if (date_start && !date_end) {
      return `after ${formatDate(date_start)}`
    } else if (date_end && !date_start) {
      return `before ${formatDate(date_end)}`
    } else {
      return "Custom Range"
    }
  }

  const date_arr = ["date_start", "date_end"]

  onMount(() => {
    if (typeof expected_at.value === "object") {
      date_start = expected_at["date_start"]
      date_end = expected_at["date_end"]
      onselected({
        value: { date_start, date_end },
        type: "expected_at",
        label: createDateRangeString({ date_start, date_end })
      })
      expected_group = "custom-range"
    } else {
      const expAt = expectedOptions.find((v) => v.value === expected_at.value)
      expected_at = expAt ? expAt : expectedOptions[0]
      onselected(expected_at)
      expected_group = expected_at.value
    }
  })
</script>

<div class="py-1 expected-options rounded-sm" data-name="date-pane">
  {#each expectedOptions as opt}
    <button
      class="inline mr-2"
      class:active={expected_group === opt.value}
      onclick={() => {
        expected_group = opt.value as string
        onselected(opt)
      }}
      tabindex="0"
    >
      {opt.label}
    </button>
  {/each}

  <button
    class="inline mr-2"
    class:active={expected_group === "custom-range"}
    onclick={() => {
      expected_group = "custom-range"
      onselected({
        value: {
          date_start: date_start,
          date_end: date_end
        }
      })
    }}
  >
    Custom Range
  </button>
</div>

<div class:hidden={expected_group !== "custom-range"}>
  <div class="grid grid-cols-2 mt-2">
    <div class="flex">
      <label for="start_date">Start Date</label>
      <input
        type="date"
        name="date_start"
        bind:value={date_start}
        onchange={() => {
          onselected({
            value: {
              date_start: date_start,
              date_end: date_end
            }
          })
        }}
        class="border-0 p-1 ml-2"
      />
    </div>

    <div class="flex">
      <label for="start_date">End Date</label>
      <input
        type="date"
        name="date_end"
        bind:value={date_end}
        onchange={() => {
          expected_group = "custom-range"
          onselected({
            value: {
              date_start: date_start,
              date_end: date_end
            }
          })
        }}
        class="border-0 ml-2"
      />
    </div>
  </div>
</div>

<style lang="css">
  .expected-options button {
    padding: 0.1rem 0.4rem;
    border-radius: 0.3rem;
    color: #777;
  }
  .expected-options .active {
    color: #1f2937;
    font-weight: bold;
  }
</style>
